import { Typography } from '@lamimed/pantheon';

import * as S from './styles';

interface StepProps {
  title: string;
  description: string;
  stepNumber: number;
  isLast?: boolean;
}

export const Step: React.FC<StepProps> = ({
  title,
  description,
  stepNumber,
  isLast = false,
}) => {
  return (
    <S.StepWrapper isLast={isLast}>
      <S.StepIndicator>
        <Typography variant="heading_4" color="text__light">
          {stepNumber}
        </Typography>
      </S.StepIndicator>

      <S.StepText>
        <Typography variant="heading_4" color="text__highlight">
          {title}
        </Typography>

        <Typography>{description}</Typography>
      </S.StepText>
    </S.StepWrapper>
  );
};
